// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./_is-regexp')
  , defined  = require('./_defined');

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_string-context.js
// module id = 174
// module chunks = 48 49 50 51